import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=33c66342"
import script from "./CambiarPassword.vue?vue&type=script&lang=js"
export * from "./CambiarPassword.vue?vue&type=script&lang=js"
import style0 from "../../components/BankInformation/bkCuenta.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../components/Cuenta/cuentaMenu.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports